import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.new_password.length < 8) return setError("New password must be at least 8 characters");
    if (f.new_password !== f.confirm) return setError("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      setOpen(false);
      setF(EMPTY);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const field = (k, label) => (
    <div>
      <Label htmlFor={k}>{label}</Label>
      <Input id={k} type="password" required autoComplete={k === "current_password" ? "current-password" : "new-password"} value={f[k]}
        onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={`change-pw-${k}-input`} />
    </div>
  );

  return (
    <>
      <Button size="sm" variant="ghost" className="text-slate-500 hover:text-[#01195D]" title="Change password" onClick={() => { setError(""); setF(EMPTY); setOpen(true); }} data-testid="change-password-btn">
        <KeyRound className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="change-password-dialog">
          <DialogHeader>
            <DialogTitle className="text-[#01195D]">Change password</DialogTitle>
            <DialogDescription>Use at least 8 characters.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            {field("current_password", "Current password")}
            {field("new_password", "New password")}
            {field("confirm", "Confirm new password")}
            {error && <p className="text-sm text-red-600" data-testid="change-pw-error">{error}</p>}
            <DialogFooter>
              <Button type="submit" disabled={busy} className="bg-[#01195D] hover:bg-[#0A2A7A]" data-testid="change-pw-submit-btn">{busy ? "Saving…" : "Update password"}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
